import OrganisationHospitalDTO from '@src/adapters/dto/hospital/OrganisationHospitalDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
  name: string;
  codeSet: string;
  regionCode?: string;
}

type Result = OrganisationHospitalDTO;

const options: ApiOptions = {
  method: 'put',
  urlPath: '/hospital/edit',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useUpdateHospitalLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useUpdateHospitalLazy;
